/**
 * The pagination duck. Default export is the reducer.
 *
 * Action Types:
 * - PAGE_FORWARD
 * - PAGE_BACK
 * - PAGE_CHANGED
 *
 * Action Creators:
 * - changePage
 * - pageForward
 * - pageBack
 */

import get from 'lodash/get';
import { PACKAGES_FETCH_SUCCEEDED, PACKAGES_FETCH_FAILED } from './packages';

import type {
  PaginationState,
  PaginationAction,
  PageChanged,
  PageForward,
  PageBack,
} from '../types';

/** @type {ActionType} */
export const PAGE_FORWARD = 'PB/pagination/PAGE_FORWARD';
/** @type {ActionType} */
export const PAGE_BACK = 'PB/pagination/PAGE_BACK';
/** @type {ActionType} */
export const PAGE_CHANGED = 'PB/pagination/PAGE_CHANGED';

export const initialState = {
  currentPage: 0,
  totalPages: 0,
  maybePage: 0,
};

/** @ignore */
export default function pagination(
  state: PaginationState = initialState,
  action: PaginationAction,
): PaginationState {
  switch (action.type) {
    case PAGE_FORWARD:
      return { ...state, maybePage: state.currentPage + 1 };

    case PAGE_BACK:
      return { ...state, maybePage: state.currentPage - 1 };

    case PAGE_CHANGED:
      const newPage = get(action, 'payload.newPage', state.currentPage);
      return { ...state, maybePage: newPage };

    case PACKAGES_FETCH_SUCCEEDED:
      const totalPages = get(
        action,
        'payload.pagination.totalPages',
        state.totalPages,
      );
      const currentPage = get(
        action,
        'payload.pagination.currentPage',
        state.currentPage,
      );
      return {
        totalPages,
        currentPage,
        maybePage: currentPage,
      };

    case PACKAGES_FETCH_FAILED:
      return { ...state, maybePage: state.currentPage };

    default:
      return state;
  }
}

export function changePage(newPage: number): PageChanged {
  return {
    type: PAGE_CHANGED,
    payload: { newPage },
  };
}

export function pageForward(): PageForward {
  return {
    type: PAGE_FORWARD,
  };
}

export function pageBack(): PageBack {
  return {
    type: PAGE_BACK,
  };
}
